// storageUtil.js
export class StorageUtil {
  // 存储到localStorage
  static setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  // 从localStorage获取数据
  static getLocalStorage(key) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  // 从localStorage删除数据
  static removeLocalStorage(key) {
    localStorage.removeItem(key);
  }

  // 清空localStorage
  static clearLocalStorage() {
    localStorage.clear();
  }

  // 存储到sessionStorage
  static setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  // 从sessionStorage获取数据
  static getSessionStorage(key) {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  // 从sessionStorage删除数据
  static removeSessionStorage(key) {
    sessionStorage.removeItem(key);
  }

  // 清空sessionStorage
  static clearSessionStorage() {
    sessionStorage.clear();
  }

  // 设置cookie
  static setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  // 判断是否存在cookie
  static hasCookie(name) {
    return this.getCookie(name) !== null;
  }

  // 获取cookie
  static getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // 删除cookie
  static removeCookie(name) {
    document.cookie = `${name}=; Max-Age=-99999999; path=/`;
  }

  // 清空所有cookie
  static clearCookies() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=; Max-Age=-99999999; path=/`;
    }
  }
}
